import styled from 'styled-components';

const Success = styled.p`
  color: var(--success-400);
  font-size: 0.9rem;
`;
export default Success;
